import { useAcessoLotacaoOrEstagio } from 'components/auth/useAcessoLotacao'
import { PageLoading } from 'components/loading'
import { useCuidadoCompartilhadoQuery } from 'graphql/hooks.generated'
import { Redirect, useParams } from 'react-router'
import { isUndefinedOrNull } from 'util/checks'

import { podeAcessarDiscussaoCuidadoCompartilhado } from '../util-cuidadoCompartilhado'
import { CuidadoCompartilhadoView } from './CuidadoCompartilhadoView'

export const CuidadoCompartilhadoRootView = () => {
  const { id } = useParams<{ id: string }>()
  const { acesso } = useAcessoLotacaoOrEstagio()

  const {
    data: { cuidadoCompartilhado },
    loading: isLoading,
  } = useCuidadoCompartilhadoQuery({ variables: { id } })

  if (isLoading) {
    return <PageLoading message='Carregando dados do cuidado compartilhado...' />
  } else if (isUndefinedOrNull(cuidadoCompartilhado)) {
    return <Redirect to='/404' />
  }

  const podeAcessarDiscussaoCC = podeAcessarDiscussaoCuidadoCompartilhado(acesso, cuidadoCompartilhado)

  if (!podeAcessarDiscussaoCC) {
    return <Redirect to='/405' />
  }

  return <CuidadoCompartilhadoView cuidadoCompartilhado={cuidadoCompartilhado} />
}
